import { render, staticRenderFns } from "./upcomingEvents.vue?vue&type=template&id=321cf288"
import script from "./upcomingEvents.vue?vue&type=script&lang=js"
export * from "./upcomingEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports